import { LanguageSelectorButton, LanguageIcon, LanguageText } from './styles';
import { Language, KeyboardArrowDown } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, MouseEvent } from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { Text } from '@/components/atoms/text';

export const languages = {
  'pt-BR': {
    label: 'Português',
    alt: 'Portuguese',
  },
  'en-US': {
    label: 'English',
    alt: 'English',
  },
};

interface LanguageSelectorProps {
  onChangeLanguage?: () => void;
}

export const LanguageSelector = ({ onChangeLanguage }: LanguageSelectorProps) => {
  const theme = useTheme();
  const { currentLanguage, setLanguage } = useLanguage();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage: 'pt-BR' | 'en-US') => {
    if (newLanguage === currentLanguage) return;

    setLanguage(newLanguage);
    onChangeLanguage?.();
    handleClose();
  };

  return (
    <>
      <LanguageSelectorButton onClick={handleClick}>
        <LanguageIcon>
          <Language />
        </LanguageIcon>
        <LanguageText>{languages[currentLanguage].label}</LanguageText>
        <KeyboardArrowDown sx={{ fontSize: '18px', ml: 'auto' }} />
      </LanguageSelectorButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            width: '155px',
          },
        }}
      >
        {Object.entries(languages).map(([key, value]) => {
          if (key === currentLanguage) return null;
          return (
            <MenuItem
              sx={{
                gap: theme.spacing(0.75),
                padding: theme.spacing(0.75, 1.5),
                fontSize: '13px',
                minHeight: 'unset',
              }}
              key={key}
              onClick={() => handleLanguageChange(key as 'pt-BR' | 'en-US')}
            >
              <Language sx={{ fontSize: '18px', color: theme.palette.action.active }} />
              <Text variant="body2" sx={{ fontSize: '13px' }}>
                {value.label}
              </Text>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
